import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './theme';
import NotFound from './Errors/NotFound';
import Home from './Content/Home/Home';
import Historia from './Content/Home/Historia';
import Basica from './Content/Home/Basica';
import Media from './Content/Home/Media';
import Diplomas from './Content/Home/Diplomas';
import Trayectorias from './Content/Home/Trayectorias';
import TrayectoriasForm from './Content/Home/TrayectoriasForm';
import TrayectoriaNUM_C1 from './Content/Home/trayectorias/NUM_C1';
import TrayectoriaNUM_C2 from './Content/Home/trayectorias/NUM_C2';
import TrayectoriaGEO_C1 from './Content/Home/trayectorias/GEO_C1';
import TrayectoriaEST_C2 from './Content/Home/trayectorias/EST_C2';
import TrayectoriaMAT_78 from './Content/Home/trayectorias/MAT_78';
import NewCoursesPopup from './Content/Home/components/NewCoursesPopup';
import { ThemeProvider } from '@mui/material/styles';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react'
import matomoConfiguration from './Auth/matomoConfig';

const matomoSetting = matomoConfiguration;

const matomoInstance = createInstance(matomoSetting);

function App() {
  return (
    <MatomoProvider value={matomoInstance}>
      <ThemeProvider theme={theme}>
        <Router>
          <NewCoursesPopup />
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/historia" element={<Historia/>} />
            <Route path="/basica" element={<Basica/>} />
            <Route path="/media" element={<Media/>} />
            <Route path="/diplomas" element={<Diplomas/>} />
            <Route path="/trayectorias" element={<Trayectorias/>} />
            <Route path="/trayectorias/formulario" element={<TrayectoriasForm/>} />
            <Route path="/trayectorias/num_c1" element={<TrayectoriaNUM_C1/>} />
            <Route path="/trayectorias/num_c2" element={<TrayectoriaNUM_C2/>} />
            <Route path="/trayectorias/geo_c1" element={<TrayectoriaGEO_C1/>} />
            <Route path="/trayectorias/est_c2" element={<TrayectoriaEST_C2/>} />
            <Route path="/trayectorias/mat_78" element={<TrayectoriaMAT_78/>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </MatomoProvider>
  );
}

export default App;